import React from 'react';
import { IRNSummaryDetails } from '../../../common/types';

import { formatInvoices } from '../../utils/formatInvoices';

import {
  MisSummaryCard,
  SummaryBox,
  SummaryCardBig,
  SummaryCardSmall,
  CardText,
  CardLabel,
  CardLabelText,
} from './styles';

// eslint-disable-next-line @typescript-eslint/naming-convention
interface summaryCardProps {
  summaryCardData: IRNSummaryDetails;
}

const MISSummaryCard: React.FC<summaryCardProps> = ({ summaryCardData }) =>  (
    <MisSummaryCard>
      <SummaryBox>
        <SummaryCardBig>
          <CardText>
            {formatInvoices(summaryCardData.totalNoOfInvoices,1)}
          </CardText>
          <CardLabel color="#E8E8E8" backgroundColor="none">
            <CardLabelText color="#6D6D6D">Total Docs</CardLabelText>
          </CardLabel>
        </SummaryCardBig>
        <SummaryCardBig>
          <CardText>
            {formatInvoices(summaryCardData.totalIrnGenerated,1)}
          </CardText>
          <CardLabel color="#DDFBE2" backgroundColor="#50CD65">
            <CardLabelText color="#574900">generated</CardLabelText>
          </CardLabel>
        </SummaryCardBig>
      </SummaryBox>
      <SummaryBox>
        <SummaryCardSmall>
          <CardText>
            {' '}
            {formatInvoices(summaryCardData.totalPendingIrnGeneration,1)}
          </CardText>
          <CardLabel color="#FFF7CE" backgroundColor="#EECE33">
            <CardLabelText color="12422E">Not Generated</CardLabelText>
          </CardLabel>
        </SummaryCardSmall>
        <SummaryCardSmall>
          <CardText>
            {formatInvoices(summaryCardData.totalIrnCancelled,1)}
          </CardText>
          <CardLabel color="#FFE5D4" backgroundColor="#FE9D54">
            <CardLabelText color="#732A00">cancelled</CardLabelText>
          </CardLabel>
        </SummaryCardSmall>
        <SummaryCardSmall>
          <CardText>
            {formatInvoices(summaryCardData.totalIrnFailed,1)}
          </CardText>
          <CardLabel color="#FFD7D5" backgroundColor="#FF685F">
            <CardLabelText color="#732A00">failed</CardLabelText>
          </CardLabel>
        </SummaryCardSmall>
      </SummaryBox>
    </MisSummaryCard>
  );

export default MISSummaryCard;
